// NotificationToast.tsx
import React from 'react'
import dayjs from 'dayjs'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as IconBell } from './../../images/icons/icon-bell.svg'
import { UserNotification } from '../../api/notifications/useGetUserNotifications'

// Dummy NotificationIcon component. Replace or import your actual component if needed.
const NotificationIcon = ({ notification }: { notification: UserNotification }) => (
  <div className="flex justify-center items-center bg-primary-glaucous/20 rounded-full p-2">
    <IconBell />
  </div>
)

export interface Notification {
  _id: string
  title: string
  message: string
  readAt?: string | null
  createdAt: string
  meta?: {
    path?: string
  }
}

interface NotificationToastProps {
  notification: UserNotification
  onClose: () => void
}

const NotificationToast: React.FC<NotificationToastProps> = ({
  notification,
  onClose,
}) => {
  const navigate = useNavigate()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (notification.meta?.path) {
      navigate(notification.meta.path)
    }
    onClose()
  }

  return (
    <div
      onClick={handleClick}
      className={classNames(
        'flex flex-row group justify-between items-center px-4 py-3 cursor-pointer bg-primary-xiketic',
      )}>
      <div className="flex flex-row gap-3 max-w-[70%] items-center">
        <NotificationIcon notification={notification} />
        <div className="flex flex-col gap-2 items-start">
          <span className="font-bold text-xs text-web-gray text-white">
            {notification.title}
          </span>
          <span className="font-bold text-xs text-web-gray text-primary-glaucous line-clamp-2">
            {notification.message}
          </span>
        </div>
      </div>
      <div className="flex flex-col h-full justify-end">
        <div className="flex flex-col gap-1 items-end">
          {!notification.readAt && (
            <div className="w-2 h-2 bg-[#0DBDE3] rounded-full group-hover:bg-transparent" />
          )}
          <span className="font-bold text-xs text-white">
            {dayjs(notification.createdAt).fromNow()}
          </span>
        </div>
      </div>
    </div>
  )
}

export default NotificationToast
